
import axiosRequest from "@/api/axios-optimize"

// 通过分类id获取品牌列表
export function getBrandListByCategoryId(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/categoryBrand/getBrandListByCategoryId`, { params: data, ...config})
}

// 通过分类id获取对应的规格属性列表
export function getSkuAttrListByCategoryId(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/categorySku/getSkuAttrListByCategoryId`, { params: data, ...config})
}

// 新增规格名称并分配给对应的分类
export function addSkuAttrByCategoryId(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/categorySku/addSkuAttrByCategoryId`, data, config)
}

// 通过规格属性ID新增规格值
export function addSkuValueBySkuAttrId(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/categorySku/addSkuValueBySkuAttrId`, data, config)
}

// 判断是否名字相同的
export function judgeGoodsNameExist(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/goods/judgeGoodsNameExist`, data, config)
}

// 判断是否编号相同的
export function judgeGoodsSnExist(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/goods/judgeGoodsSnExist`, data, config)
}

// 新增
export function createItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/goods`, data, config)
}

// 获取列表
export function getList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/goods`, { params: data, ...config})
}

// 获取详情
export function getDetailById(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/goods/${data.id}`, { params: {}, ...config})
}

// 更新
export function updateItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.put(`/xiaobuAdmin/product/goods/${data.goodsId}`, data, config)
}

// 删除
export function deleteItem(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.delete(`/xiaobuAdmin/product/goods/${data.id}`, { ...config}) // 省略data入参 或 params入参
}

// 批量删除
export function batchDeleteItems(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.delete(`/xiaobuAdmin/product/goods/batchDelete`, {data, ...config})
}

// 改变状态
export function changeStatus(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/goods/changeStatus`, data, config)
}

// 获取是否可以编辑商品规格及属性
export function getControlByGoodsId(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/goods/getControlByGoodsId`, { params: data, ...config})
}

// 根据分类id 获取最新的参数配置
export function getParamsByCategoryId(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/goods/getParamsByCategoryId`, { params: data, ...config})
}

// 获取商品编号
export function generateGoodsSn(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/goods/generateGoodsSn`, { params: data, ...config})
}